// @ts-nocheck legacy file transformed to TS
import React from 'react'
import LoadingDots from 'legacy/components/LoadingDots'

const TableLoader = () => <LoadingDots height={10} centered />

export default TableLoader
